import type { GetLocationCityInputs } from '@bond/bruce-api/api/location/city/get'
import type { CityIncludesWithToken } from '@bond/bruce-api/api/location/city/response'
import type { CityId } from '@bond/bruce-api/common/city'

export function getCityNamesByCityId<T extends GetLocationCityInputs>(
  cities: CityIncludesWithToken<T>[],
) {
  return cities.reduce(
    (acc: Record<string, string>, currentCity) => ({
      ...acc,
      [currentCity.id]: currentCity.name,
    }),
    {},
  ) as { [key in CityId]: string }
}
